<template>
  <div class="container">
    <h1>Data Sources & Disclaimer</h1>
    <p>
      Litely uses AI, including image recognition and estimation models, to
      identify foods from photos and generate estimated calorie and nutrition
      values. These estimates are informed by established public nutrition data
      sources, including the USDA’s FoodData Central, which is one of the main
      official food composition resources in the United States.
    </p>
    <p>
      Nutrition information shown in Litely is intended to help users track food
      more easily and understand estimated values such as calories and nutrients
      in a practical way. In the U.S., nutrition information is commonly
      interpreted through standards such as the FDA’s Nutrition Facts framework,
      which explains how calories and nutrient amounts are presented to
      consumers.
    </p>
    <p>
      Because Litely’s results are generated through AI recognition and
      database-based estimation, they are not exact measurements. Values may
      vary due to portion size, cooking method, sauces, mixed ingredients,
      restaurant variation, brand differences, and image quality. For this
      reason, all calorie and nutrition information in the app should be treated
      as a general reference only.
    </p>
    <p>
      Litely is not intended to diagnose, treat, cure, or prevent any disease,
      and it does not replace advice from a physician, registered dietitian, or
      other qualified healthcare professional. Before making medical decisions
      or significant changes to diet, supplements, or exercise, users should
      consult a licensed healthcare provider.
    </p>
    <h2>Suggested References</h2>
    <ul>
      <li>
        <a
          href="https://fdc.nal.usda.gov/?utm_source=chatgpt.com"
          target="_blank"
          rel="noopener"
          >USDA FoodData Central</a
        >
      </li>
      <li>
        <a
          href="https://www.nal.usda.gov/human-nutrition-and-food-safety/food-composition?utm_source=chatgpt.com"
          target="_blank"
          rel="noopener"
          >USDA Food Composition Resources</a
        >
      </li>
      <li>
        <a
          href="https://www.fda.gov/food/nutrition-facts-label/how-understand-and-use-nutrition-facts-label?utm_source=chatgpt.com"
          target="_blank"
          rel="noopener"
          >FDA: How to Understand and Use the Nutrition Facts Label</a
        >
      </li>
      <li>
        <a
          href="https://www.fda.gov/food/nutrition-education-resources-materials/nutrition-facts-label?utm_source=chatgpt.com"
          target="_blank"
          rel="noopener"
          >FDA: The Nutrition Facts Label</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    let type = this.$route.params.type;
    if (type === "app") {
      this.$store.commit("setIsApp", true);
    } else {
      this.$store.commit("setIsApp", false);
    }
  },
  mounted() {},
  components: {},
  computed: {},
  methods: {},
};
</script>

<style lang="less" scoped>
@import "@/css/less_custom.less";

.container {
  width: 70%;
  min-height: auto;
  margin: 0 auto;
  margin-bottom: 100px;
  margin-top: 60px;

  p {
    text-align: left !important;
    margin-top: 7px;
  }

  h1 {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  h2,
  h3 {
    margin-top: 10px;
    text-align: left;
  }

  ul {
    text-align: left;
    padding-left: 20px;
    list-style-type: disc;

    li {
      margin-top: 5px;
      list-style-type: disc;
    }
  }
}
</style>
